export default __webpack_public_path__ + "08ffd124e2d8426a91dc57b4b28b1748.svg";